/* eslint-disable react/button-has-type */
import React, { useContext, useRef } from 'react'
import { Dropdown } from 'antd'
import cls from 'classnames'
import styled, { ThemeContext } from 'styled-components'

import useDownloadHandler from 'utils/hooks/useDownloadHandler'

import Icon from 'components/lib/Icon'
import OldModal from 'components/lib/modules/OldModal'
import Popup from 'components/lib/Popup'

import { Loader } from './DesignSystem/Icons'
import StatusDot from './DesignSystem/StatusDot'

const ButtonContainer = ({
  id,
  className,

  icon,
  text,
  type,
  title,
  style,
  popup, // { text, position }
  goBack,
  loader,
  disabled,
  arrowRight,
  confirmationModal, // { text }
  onClick,
  counter,
  leftIcon,
  rightIcon,

  LeftIconDS, // renders DS icon instead of rendering old way
  RightIconDS,
  dsIconStyles,

  iconStyle,
  href,
  downloadObj,
  downloadIt,
  split,
  options,
  dropdownArgs = {},
  active,
  statusDotProps,
}) => {
  const theme = useContext(ThemeContext)
  const { handleDownloadClick, isLoading } = useDownloadHandler()
  const isDisabled = disabled || loader || isLoading
  const ccn = cls(
    'is-button typography-subtitle-2',
    className,
    { disabled: isDisabled, active },
    { loader }
  )
  const wrapperRef = useRef(null)
  const handleOnClick = (e) => {
    if (isDisabled) return

    if (downloadIt || downloadObj) {
      handleDownloadClick({ e, downloadIt, isDisabled, downloadObj, href })
    } else if (typeof onClick === 'function') {
      onClick(e)
    }
  }

  const Button = (
    <button
      id={id}
      style={style}
      className={ccn}
      type={type}
      onClick={handleOnClick}
      title={title}
      disabled={isDisabled}
    >
      {!!loader || isLoading ? (
        <div className="button-loader-wrapper">
          <Loader
            style={{ animationDuration: '1000ms' }}
            spin
            fill={theme.white}
            width="20px"
            height="20px"
          />
        </div>
      ) : null}
      <Popup
        position={popup?.position || 'top'}
        ContentComponent={popup ? popup.text : null}
        style={{ maxWidth: 'unset' }}
        TriggerComponent={
          <div className="is-button-internal-container">
            {statusDotProps?.status && <StatusDot {...statusDotProps} />}
            {!!icon && (
              <img src={`/static/webapp/images/button-icons/${icon}.svg`} className="dib-vac" />
            )}
            {LeftIconDS && <LeftIconDS className="left-icon" {...dsIconStyles} />}
            {leftIcon && <Icon noHover imageName={leftIcon} className="left-icon" {...iconStyle} />}
            {!!goBack && <i className="icon-arrow-left mr" />}
            <span className="dib-vac typography-subtitle-2">{text}</span>
            {RightIconDS && <RightIconDS className="right-icon" {...dsIconStyles} />}
            {rightIcon && (
              <Icon noHover imageName={rightIcon} className="right-icon" {...iconStyle} />
            )}
            {!!arrowRight && <i className="icon-arrow-right ml" />}
            {!!counter && <div className="button-counter">{counter > 99 ? '99+' : counter}</div>}
          </div>
        }
      />
    </button>
  )

  let Component = split ? (
    <div ref={wrapperRef}>
      <Dropdown
        id="storybook_select"
        menu={{ items: options }}
        placement="bottomLeft"
        trigger={['click']}
        {...dropdownArgs}
        getPopupContainer={() => wrapperRef.current}
      >
        <div>{Button}</div>
      </Dropdown>
    </div>
  ) : (
    <>{Button}</>
  )

  if (confirmationModal && !disabled) {
    Component = (
      <OldModal
        trigger={Component}
        size="mini"
        confirm={handleOnClick}
        customConfirmYes="Yes"
        customConfirmNo="No"
      >
        <div className="tac mt">{confirmationModal.text}</div>
      </OldModal>
    )
  }

  return Component
}

export default styled(ButtonContainer)`
  .ant-dropdown-menu {
    color: ${({ theme }) => theme.colors.text.primary};
    padding: 8px;
    margin-top: -4px;
  }

  .ant-dropdown-menu-item {
    color: ${({ theme }) => theme.colors.text.primary};
    padding: 7px 8px;
    border-radius: 4px;

    &:hover {
      background-color: ${({ theme }) => theme.colors.background.dropdown.hover};
    }
  }

  * {
    ::-webkit-scrollbar {
      width: 4px;
    }
    ::-webkit-scrollbar-thumb {
      -webkit-border-radius: 4px;
      border-radius: 4px;
      background: #e4e4e4;
    }
  }
`
